import { h } from 'preact';
import Header from '../../components/header';
import Generator from '../../components/generator';

const Home = () => {
	return (
		<>
			<Header proVersion={false} />
			<main class="">
				<p>hey! space bar also generates a new gradient texture!</p>
				<Generator proVersion={false} downloadMessage="Downloaded image is 1000x1000px" />
			</main>
		</>
	);
}

export default Home;
